import { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { FaEnvelope } from 'react-icons/fa';

const teamMembers = [
  {
    name: "Prof. Dr. Jean-Baptiste KOUADIO",
    role: "Recteur",
    photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400",
    parcours: "Docteur en Sciences Économiques de l'Université Paris-Sorbonne. Plus de 25 ans d'expérience dans l'enseignement supérieur.",
    cv: "Expert reconnu en économie du développement avec plusieurs publications internationales. Ancien conseiller économique au ministère de l'Économie et des Finances.",
    missions: "Diriger l'institution, définir la vision stratégique, superviser les programmes académiques et maintenir les standards d'excellence."
  },
  {
    name: "Dr. Amélie TOURE",
    role: "Vice-Rectrice aux Affaires Académiques",
    photo: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400",
    parcours: "Doctorat en Pédagogie de l'Université McGill, Canada. Spécialiste en innovation pédagogique.",
    cv: "15 ans d'expérience dans la gestion académique. A piloté plusieurs projets d'excellence pédagogique dans différentes universités africaines.",
    missions: "Coordonner les programmes d'études, assurer la qualité de l'enseignement, développer les méthodes pédagogiques innovantes."
  },
  {
    name: "M. Koffi ASSOUÉ",
    role: "Directeur Administratif et Financier",
    photo: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400",
    parcours: "Master en Gestion Financière, CFA Charterholder. Expert en gestion d'établissements d'enseignement supérieur.",
    cv: "20 ans d'expérience en gestion financière et administrative dans le secteur éducatif. Ancien directeur financier d'une grande école de commerce.",
    missions: "Gérer les ressources financières, superviser les opérations administratives, assurer la pérennité financière de l'institution."
  },
  {
    name: "Dr. Fatou DIALLO",
    role: "Doyenne de la Faculté des Sciences",
    photo: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400",
    parcours: "Doctorat en Physique Appliquée de l'Université de Lyon. Chercheuse renommée en énergie renouvelable.",
    cv: "Auteure de plus de 50 publications scientifiques. Membre de plusieurs sociétés savantes internationales.",
    missions: "Diriger la faculté des sciences, développer la recherche, encadrer les étudiants en sciences et promouvoir l'innovation scientifique."
  },
  {
    name: "M. Ibrahim SANGARÉ",
    role: "Doyen de la Faculté de Droit",
    photo: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400",
    parcours: "Docteur en Droit International de l'Université de Genève. Avocat inscrit au barreau d'Abidjan.",
    cv: "Expert en droit des affaires et droit international. Consultant pour plusieurs organisations internationales.",
    missions: "Superviser les programmes de droit, développer les partenariats avec le secteur juridique, former les futurs juristes."
  },
  {
    name: "Mme. Sophie N'GUESSAN",
    role: "Directrice des Relations Internationales",
    photo: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400",
    parcours: "Master en Relations Internationales de Sciences Po Paris. Spécialiste en coopération universitaire.",
    cv: "10 ans d'expérience en développement de partenariats internationaux. A établi des accords avec plus de 30 universités à travers le monde.",
    missions: "Développer les partenariats internationaux, coordonner les programmes d'échange, promouvoir la mobilité étudiante."
  }
];

export default function Equipe() {
  const [selectedMember, setSelectedMember] = useState(null);

  return (
    <div className="min-h-screen bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 text-brand-secondary">Équipe Dirigeante</h1>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto">
            Rencontrez les leaders qui guident l'Université CEFAT International vers l'excellence
          </p>
        </div>

        {/* Team Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {teamMembers.map((member, index) => (
            <Card 
              key={index} 
              className="overflow-hidden card-hover bg-white shadow-md cursor-pointer"
              data-testid={`team-member-${index}`}
              onClick={() => setSelectedMember(member)}
            >
              <div className="h-64 overflow-hidden">
                <img 
                  src={member.photo} 
                  alt={member.name}
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-brand-secondary mb-2">{member.name}</h3>
                <p className="text-brand-primary font-semibold mb-3">{member.role}</p>
                <p className="text-gray-600 text-sm line-clamp-2">{member.parcours}</p>
                <Button 
                  data-testid={`view-details-btn-${index}`}
                  className="mt-4 w-full bg-brand-primary hover:bg-brand-primary-dark text-white"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedMember(member);
                  }}
                >
                  Voir les détails
                </Button>
              </div>
            </Card>
          ))}
        </div>

        {/* Detailed View */}
        {selectedMember && (
          <div className="mb-16">
            <div className="bg-gradient-to-r from-brand-primary/10 to-brand-secondary/10 p-2 rounded-lg">
              <Card className="p-8 bg-white">
                <div className="grid md:grid-cols-3 gap-8 mb-8">
                  <div className="text-center">
                    <img 
                      src={selectedMember.photo} 
                      alt={selectedMember.name}
                      className="w-48 h-48 rounded-full mx-auto mb-4 object-cover shadow-lg"
                    />
                    <h2 className="text-2xl font-bold text-brand-secondary mb-2">{selectedMember.name}</h2>
                    <p className="text-brand-primary font-semibold text-lg mb-4">{selectedMember.role}</p>
                    <Button 
                      data-testid="contact-member-btn"
                      className="bg-brand-secondary hover:bg-brand-secondary/90 text-white"
                    >
                      <FaEnvelope className="mr-2" />
                      Contacter
                    </Button>
                  </div>
                  
                  <div className="md:col-span-2">
                    <Tabs defaultValue="cv" className="w-full">
                      <TabsList className="grid w-full grid-cols-2 bg-gray-100 p-2 rounded-lg mb-6">
                        <TabsTrigger 
                          value="cv" 
                          data-testid="tab-cv"
                          className="data-[state=active]:bg-brand-primary data-[state=active]:text-white font-semibold py-3 rounded-md transition-all"
                        >
                          CV & Parcours
                        </TabsTrigger>
                        <TabsTrigger 
                          value="missions" 
                          data-testid="tab-missions"
                          className="data-[state=active]:bg-brand-primary data-[state=active]:text-white font-semibold py-3 rounded-md transition-all"
                        >
                          Missions
                        </TabsTrigger>
                      </TabsList>

                      <TabsContent value="cv" className="space-y-4">
                        <div>
                          <h3 className="text-xl font-bold text-brand-primary mb-3">Parcours</h3>
                          <p className="text-gray-700 leading-relaxed">{selectedMember.parcours}</p>
                        </div>
                        <div>
                          <h3 className="text-xl font-bold text-brand-primary mb-3">Expérience</h3>
                          <p className="text-gray-700 leading-relaxed">{selectedMember.cv}</p>
                        </div>
                      </TabsContent>

                      <TabsContent value="missions" className="space-y-4">
                        <div>
                          <h3 className="text-xl font-bold text-brand-primary mb-3">Missions Principales</h3>
                          <p className="text-gray-700 leading-relaxed">{selectedMember.missions}</p>
                        </div>
                      </TabsContent>
                    </Tabs>
                  </div>
                </div>
              </Card>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}